export const StatTile = ({ value, label }) => (
  <div className="p-6" style={{ background: "var(--navy-100)", borderRadius: "var(--radius-md)" }}>
    <div className="stat-value mb-2">{value}</div>
    <div className="stat-label">{label}</div>
  </div>
);
